import { getRewardsString } from "halifax";
import { RewardsPrice } from "redmond";

export const TITLE = "Cancel for any reason successfully added to your trip!";
export const SUBTITLE_EARN = (rewardsText: RewardsPrice) =>
  `You've earned <b>${getRewardsString(
    rewardsText,
  )}</b> by adding Cancel for any reason to your trip!`;
export const SUBTITLE_EMAIL = (email: string) =>
  `An email confirmation will be sent to ${email}.`;
export const START_NEW_SEARCH = "Start a new search";
export const VIEW_TRIP_DETAILS = "View trip details";
export const NEED_TO_CANCEL = "Need to cancel your flight?";
export const STEP_ONE = `Navigate to "My Trips"`;
export const STEP_TWO =
  "Find the flight you have added Cancel for any reason to";
export const STEP_THREE = `Select "Cancel for any reason"`;
export const STEP_THREE_BODY = (serviceExpiryDate: string) =>
  `From there, simply follow the steps to complete your cancellation. No need to contact support or the airline. Remember, you must cancel up until ${serviceExpiryDate}.`;
